import CleaningIcon from '../Images/cleaning-icon.svg'


const allService = [
{
    id: 1, 
    image: CleaningIcon,
    option: 'Studio Flat',
    desc: 'Entire Studio Apartment, Kitchen & Appliances, Bathroom & Toilet, Deep Carpet Cleaning'  
}, 

{
    id: 2, 
    image: CleaningIcon,
    option: '1 Bedroom Flat',
    desc: '1 Bedroom, 1 Bathroom, 1 Kitchen, 1 Living room, 1 Hallaway, Deep Carpet Cleaning, Kitchen Appliances'  
},
{
    id: 3, 
    image: CleaningIcon,
    option: '2 Bedroom Flat',
    desc: '2 Bedroom, 1 Bathroom, 1 Kitchen, 1 Living room, 1 Hallaway, Deep Carpet Cleaning, Kitchen Appliances'
},{
    id: 5, 
    image: CleaningIcon,
    option: '3 Bedroom Flat',
    desc: ''  
},{
    id: 6, 
    image: CleaningIcon,
    option: '4 Bedroom Flat',
    desc: ''  
},{
    id: 7, 
    image: CleaningIcon,
    option: '5 Bedroom Flat',
    desc: ''  
},{
    id: 8, 
    image: CleaningIcon,
    option: '6 Bedroom Flat',
    desc: '6 Bedroom, 1 Bathroom, 1 Kitchen, 1 Living room, 1 Hallaway,  Deep Carpet Cleaningm, Kitchen Appliances'  
},{
    id: 9, 
    image: CleaningIcon,
    option: '7 Bedroom Flat',
    desc: '7 Bedroom, 1 Bathroom, 1 Kitchen, 1 Living room, 1 Hallaway,  Deep Carpet Cleaningm, Kitchen Appliances'  
},{
    id: 10, 
    image: CleaningIcon,
    option: '8 Bedroom Flat',
    desc: '8 Bedroom, 1 Bathroom, 1 Kitchen, 1 Living room, 1 Hallaway,  Deep Carpet Cleaning, Kitchen Appliances'  
},{
    id: 11, 
    image: CleaningIcon,
    option: 'Bedroom',
    desc: ''  
},{
    id: 12, 
    image: CleaningIcon,
    option: 'Bathroom',
    desc: ''  
},{
    id: 13, 
    image: CleaningIcon,
    option: 'Toilet',
    desc: ''  
},{
    id: 14, 
    image: CleaningIcon,
    option: 'Living Room',
    desc: ''  
},{
    id: 15, 
    image: CleaningIcon,
    option: 'Kitchen',
    desc: ''  
},{
    id: 16, 
    image: CleaningIcon,
    option: 'Garage',
    desc: ''  
},{
    id: 17, 
    image: CleaningIcon,
    option: 'Balcony',
    desc: ''  
},{
    id: 18, 
    image: CleaningIcon,
    option: 'Study Room',
    desc: ''  
},{
    id: 19, 
    image: CleaningIcon,
    option: 'Utility Room',
    desc: ''  
},{
    id: 20, 
    image: CleaningIcon,
    option: 'Dining Room',
    desc: ''  
},

{
    id: 21, 
    image: CleaningIcon,
    option: 'Guest Room',
    desc: ''  
},{
    id: 22, 
    image: CleaningIcon,
    option: 'Office Room',
    desc: ''  
},{
    id: 23, 
    image: CleaningIcon,
    option: 'Playroom',
    desc: ''  
},{
    id: 24, 
    image: CleaningIcon,
    option: 'Gym Room',
    desc: ''  
},{
    id: 25, 
    image: CleaningIcon,
    option: 'Attic',
    desc: ''  
},{
    id: 26, 
    image: CleaningIcon,
    option: 'Lounge / Dining Room',
    desc: 'Deep Cleaning Of Carpet, Using Water Extractor Machine, Eco-Friendly Products, Quick Dry'  
},{
    id: 27, 
    image: CleaningIcon,
    option: 'Through Lounge',
    desc: 'Deep Cleaning Of Carpet, Using Water Extractor Machine, Eco-Friendly Products, Quick Dry'  
},
{
    id: 28, 
    image: CleaningIcon,
    option: 'Hallway',
    desc: 'Deep Cleaning Of Carpet, Using Water Extractor Machine, Eco-Friendly Products, Quick Dry'  
},{
    id: 29, 
    image: CleaningIcon,
    option: 'Staircase',
    desc: 'Deep Cleaning Of Carpet, Using Water Extractor Machine, Eco-Friendly Products, Quick Dry'  
},{
    id: 30, 
    image: CleaningIcon,
    option: 'Single Bedroom',
    desc: 'Deep Cleaning Of Carpet, Using Water Extractor Machine, Eco-Friendly Products, Quick Dry'  
},{
    id: 31, 
    image: CleaningIcon,
    option: 'Medium Rug',
    desc: 'Deep Cleaning Of Carpet, Using Water Extractor Machine, Eco-Friendly Products, Quick Dry'  
},{
    id: 32, 
    image: CleaningIcon,
    option: 'Single Oven',
    desc: 'Unplug appliance, Wipe exterior, Clean interior, Reassemble components, Eco-Friendly Products'  
},{
    id: 33, 
    image: CleaningIcon,
    option: 'Double Oven',
    desc: 'Unplug appliance, Wipe exterior, Clean interior, Reassemble components, Eco-Friendly Products'  
},{
    id: 34, 
    image: CleaningIcon,
    option: 'Aga Cooker',
    desc: 'Unplug appliance, Wipe exterior, Clean interior, Reassemble components, Eco-Friendly Products'  
},{
    id: 35, 
    image: CleaningIcon,
    option: 'Studio Flat',
    desc: 'Dusting all surfaces and furniture, Vacuuming carpets and floors, Mopping hard floors, Cleaning the bathroom, Wiping down kitchen surfaces, Emptying trash bins, Changing bed linens'  
},
{
    id: 36, 
    image: CleaningIcon,
    option: '1 Bedroom Flat',
    desc: 'Dusting all surfaces and furniture, Vacuuming carpets and floors, Mopping hard floors, Cleaning the bathroom, Wiping down kitchen surfaces, Emptying trash bins, Changing bed linens'  
},{
    id: 37, 
    image: CleaningIcon,
    option: '2 Bedroom Flat',
    desc: 'Dusting all surfaces and furniture, Vacuuming carpets and floors, Mopping hard floors, Cleaning the bathroom, Wiping down kitchen surfaces, Emptying trash bins, Changing bed linens'  
},{
    id: 38, 
    image: CleaningIcon,
    option: 'Up to 50 Square Meter',
    desc: 'For all exterior areas'  
},{
    id: 39, 
    image: CleaningIcon,
    option: '50 to 100 Square Meter',
    desc: 'For all exterior areas'  
},{
    id: 40, 
    image: CleaningIcon,
    option: '100 to 150 Square Meter',
    desc: 'For all exterior areas'  
},{
    id: 41, 
    image: CleaningIcon,
    option: '150 Square Meter and more',
    desc: 'For all exterior areas'  
},
]


export default allService;